import PropTypes from "prop-types";
import React from "react";
import { Row } from "antd";
import { connect } from "react-redux";
import TabsComponent from "../Tabs/Tabs";
import {
  ContentWrapper,
  ShowLessWrap,
  ImageWrap,
  ContinueWrap
} from "./styles";
import PercentInput from "../PercentInput";
import {
  savePercentage,
  showRemainingPercentage,
} from "../../../../actions";
import {
  PillButtonSelect,
  UnderlinelinkRemove
} from "../LegacyAccordions/styles";
import upArrow from "../../../../../../assets/icons/short-arrow-t-green.svg";
import {
  PillButtonGreen,
  PillButtonGreenWrap
} from "../Tabs/styles";
import Constants from "../../../../constants";
import { initiateTracking, recordError } from "../../../../../../utils/commonUtil";
import AlertBox from "../../../../../../CommonComponents/AlertBox";
import { CapsuleButton } from "../../../../../../CommonComponents/Commons/commonComponents";
class AccordionContent extends React.Component {

  removePopupContent = {
    heading: "Remove Information",
    line1: "<p>Are you sure you want to remove information?</p><p>Do you want to continue?</p>",
    continue: "continue",
    cancel: "No, take me back"
  };

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      saved: "none",
      validateForm: false,
      allFormsValidFromParent: []
    };
  }


  handleSave = () => {
    try {
      initiateTracking("buttonStep", Constants.PAGE_TITLE, this.props.head, "Save and Continue");
      this.props.handleChange("saved");
      this.props.showRemainingPercentage({
        showRemainingPercentage: true,
        key: this.props.contentKey,
        value: true
      });
    } catch (error) {
      recordError(error);
    }
  };

  handlePercentUpdate = ({ percentage, isFormValid }) => {
    const legacyData = this.props.legacy;    
    if (percentage && isFormValid) {
      legacyData.assignedPercentage = percentage;
      legacyData.selected = true;
      legacyData.hasChange = true;
    } else {
      legacyData.assignedPercentage = "";
      legacyData.selected = false;
      legacyData.hasChange = false;
    }
    this.props.savePercentage({
      legacyValue: legacyData,
      contentKey: this.props.contentKey
    });
  };

  getMaxTabs = id => {
    if (id === 1) {
      return 2;
    } else if (id === 2) {
      return 6;
    } else {
      return 20;
    }
  };

  handleRemoveState = () => {
    this.setState({
      show: true
    });
  };
  closeModal = () => {
    this.setState({
      show: false
    });
  };
  handleRemove = () => {
    this.setState({
      show: false,
      saved: "cancelled"
    });
    this.props.handleRemove();
  };

  showPercentageError = () => {
    this.setState({
      validateForm: true
    });
  };

  manipulateAllFormsValid = () => {
    this.setState({ allFormsValidFromParent: !this.state.allFormsValidFromParent });
  };

  render() {

    const data = this.props.legacy;
    const { validateForm } = this.state;
    
    return (
      <ContentWrapper data-test="contentWrapperAccordion">
        <AlertBox
          field_page="Edit legacy options"
          name="Remove Info"
          show={this.state.show}
          primaryBtnEvent={this.handleRemove.bind(this)}
          secondaryBtnEvent={this.closeModal.bind(this)}
          defaultContent={this.removePopupContent}
        />
        <PercentInput data-test="contentPercentAccordion"
          percentage={this.props.value}
          id={this.props.id}
          title={
            data.optionId === 1
              ? "Total percentage for all successor advisors"
              : data.optionId === 3
              ? "Percentage to endow"
              : "Percentage"
          }
          handleFormChange={this.handlePercentUpdate}
          validateForm={validateForm}
          manipulateAllFormsValid={this.manipulateAllFormsValid}
        />

        {data.optionId === 1 || data.optionId === 2 || data.optionId === 4 ? (
          <TabsComponent
            data-test="contentTabsComponent"
            selectedPlans={this.props.selectedPlans}
            handleChange={this.props.handleChange}
            handleRemove={this.props.handleRemove}
            contentKey={this.props.contentKey}
            optionId={data.optionId}
            head={this.props.head}
            maxTabs={this.getMaxTabs(data.optionId)}
            validatePercentForm={this.showPercentageError}
            allFormsValidFromParent={this.state.allFormsValidFromParent}
          />
        ) : data.optionId === 3 || data.optionId === 5 ? (
          <Row data-test="contentRow">
            {/* Check for save and continue button */}
            {this.props.percentage ? (
              <ContinueWrap data-test="contentRemoveLink">
                <PillButtonGreenWrap >
                  <PillButtonGreen  data-test="buttonSaveAndCont" onClick={this.handleSave}>Save and Continue</PillButtonGreen>

                  
                  <UnderlinelinkRemove  onClick={this.handleRemoveState} className="inline-block" data-test="buttonRemoveLink">
                    Remove
                  </UnderlinelinkRemove>
                </PillButtonGreenWrap>
              </ContinueWrap>
            ) : (
              <ShowLessWrap data-test="contentShowLess">
          
            <CapsuleButton text="Show Less" onClick={this.props.handleChange} id={`btnShowLess${data.optionId}`} whiteBackground iconType="arrowUp" width="135px"  mobWidth="135px" />

              </ShowLessWrap>
            )}
          </Row>
        ) : (
          <ShowLessWrap data-test="contentShowLessButton">
    
          <CapsuleButton text="Show Less" onClick={this.props.handleChange} id={`btnShowLess${data.optionId}`} whiteBackground iconType="arrowUp"   mobWidth="135px" styles="width135px"/>

          </ShowLessWrap>
        )}
      </ContentWrapper>
    );
  }
}

AccordionContent.propTypes = {
  contentKey: PropTypes.string,
  handleChange: PropTypes.func,
  handleRemove: PropTypes.func,
  head: PropTypes.string,
  legacy: PropTypes.shape({
    accountId: PropTypes.number,
    assignedPercentage: PropTypes.number,
    hasChange: PropTypes.bool,
    note: PropTypes.any,
    optionId: PropTypes.number,
    optionName: PropTypes.string,
    otherSuccessionDetailsList: PropTypes.any,
    planType: PropTypes.any,
    selected: PropTypes.bool,
    successionPlanGranteeOrg: PropTypes.arrayOf(PropTypes.any),
    successionPlanId: PropTypes.number,
    successorAdvisor: PropTypes.any
  }),
  percentage: PropTypes.number,
  savePercentage: PropTypes.func,
  showRemainingPercentage: PropTypes.func,
  value: PropTypes.number
};

const mapStateToProps = (state, ownProps) => ({
  legacy: state.getIn(["myAccount", "legacyValues", `${ownProps.contentKey}`]),
  percentage: state.getIn([
    "myAccount",
    "legacyValues",
    `${ownProps.contentKey}`,
    "assignedPercentage"
  ])
});

const mapDispatchToProps = dispatch => ({
  savePercentage: val => dispatch(savePercentage(val)),
  showRemainingPercentage: val => dispatch(showRemainingPercentage(val)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccordionContent);
